import { createAction, createReducer } from 'deox';

export interface TwoWayHybridApply {
  echoSessionId: string | null;
  apprlCallBackUrl: string | null;
  nonApprlCallBackUrl: string | null;
}

export interface TwoWayHybridApplyState {
  entity: TwoWayHybridApply;
}

export const defaultState: TwoWayHybridApplyState = {
  entity: {
    echoSessionId: null,
    apprlCallBackUrl: null,
    nonApprlCallBackUrl: null,
  },
};

export const setTwoWayHybridApply = createAction(
  'SET_TWO_WAY_HYBRID_APPLY',
  resolve => (data: Partial<TwoWayHybridApply>) => resolve(data),
);

export const twoWayHybridApplyReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(setTwoWayHybridApply, (state, { payload: data }) => {
      return {
        ...state,
        entity: {
          ...state.entity,
          ...data,
        },
      };
    }),
  ],
);

export interface MountedState {
  twoWayHybridApply: ReturnType<typeof twoWayHybridApplyReducer>;
}

export const selectTwoWayHybridApply = (
  state: MountedState,
): TwoWayHybridApply => state.twoWayHybridApply.entity;

export const selectTwoWayHybridApplyReducer = (
  state: MountedState,
): TwoWayHybridApply => state.twoWayHybridApply.entity;

export default twoWayHybridApplyReducer;
